/**
 * Read a paged list to the end.
 *
 * The CRM's four lists were fetched with `limit: 1000` and whatever came back
 * was treated as the whole table. That was right for a year and wrong the day
 * the tracker sync started carrying every capture type: 1,432 deals in the
 * database, 1,000 in the browser, and 432 leads that were never on the board
 * at all.
 *
 * Nothing failed. No error, no empty state, no short count anywhere on
 * screen. It surfaced as one lead being in the tracker, in the database,
 * correct in every column, and not on the board — and it took three rounds of
 * checking that row before anybody thought to check the fetch.
 *
 * So the rule is here, in one place, with no dependency on the environment so
 * it can be tested directly: ask for a page, read `total`, keep going. The
 * server still caps a page; it just cannot silently truncate the answer.
 */
export async function listAll(resource, page = 1000) {
  const first = await resource.list({ limit: page });
  const out = first.data || [];
  const total = Number(first.total) || out.length;

  /* A server that stops sending rows ends the loop whatever the total says,
     so a wrong count upstream cannot spin this for ever. */
  for (let offset = out.length; offset < total; ) {
    // eslint-disable-next-line no-await-in-loop
    const next = await resource.list({ limit: page, offset });
    const rows = next.data || [];
    if (!rows.length) break;
    out.push(...rows);
    offset += rows.length;
  }

  /*
   * And say so if it still does not add up.
   *
   * The failure this replaces was silent. If the server ever changes what it
   * returns, this line is what will be in the console instead of somebody
   * spending an afternoon on one missing lead.
   */
  if (total && out.length !== total) {
    console.warn(`[paging] asked for ${total} rows and got ${out.length}`);
  }
  return out;
}

export default listAll;
